import { LinearProgress as MPLinearProgress } from '@material-ui/core';
import styled from 'styled-components';

export const Box = styled.div`
  width: 50%;
  position: fixed;
  bottom: 50px;
  span {
    color: #fff;
  }
`;

export const LinearProgress = styled(MPLinearProgress)`
  width: 100%;
  &.MuiLinearProgress-root {
    height: 6px;
    border-radius: 6px;
    width: 60%;
    box-shadow: 0px 0px 46px 6px rgba(255,255,255,0.8);
  }
  &.MuiLinearProgress-colorPrimary {
    background-color: rgba(0, 0, 0, 0.5);
  }
  & .MuiLinearProgress-barColorPrimary {
    background-color: #ffffff;
  }
`;

export const LoadingSpinner = styled.div`
  display: block;
  position: fixed;
  width: 80px;
  height: 80px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;

  div {
    animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    transform-origin: 40px 40px;

    &:after {
      content: " ";
      display: block;
      position: absolute;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #cef;
      margin: -4px 0 0 -4px;
    }

    &:nth-child(1) {
      animation-delay: -0.036s;

      &:after {
        top: 63px;
        left: 63px;
      }
    }

    &:nth-child(2) {
      animation-delay: -0.072s;

      &:after {
        top: 68px;
        left: 56px;
      }
    }

    &:nth-child(3) {
      animation-delay: -0.108s;

      &:after {
        top: 71px;
        left: 48px;
      }
    }

    &:nth-child(4) {
      animation-delay: -0.144s;

      &:after {
        top: 72px;
        left: 40px;
      }
    }

    &:nth-child(5) {
      animation-delay: -0.18s;

      &:after {
        top: 71px;
        left: 32px;
      }
    }

    &:nth-child(6) {
      animation-delay: -0.216s;

      &:after {
        top: 68px;
        left: 24px;
      }
    }

    &:nth-child(7) {
      animation-delay: -0.252s;

      &:after {
        top: 63px;
        left: 17px;
      }
    }

    &:nth-child(8) {
      animation-delay: -0.288s;

      &:after {
        top: 56px;
        left: 12px;
      }
    }
  }
`